<template>
  <div>
    <el-row v-if="centralizedPurchaseInfo.component === 'centralizedPurchase'">
      <el-col :span="4" class="padding-right-0">
        <div class="bg-white treeview">
          <ul class="list-group text-center">
            <li 
              class="list-group-item node-orgTree"
              v-for="(item,index) in centralizedPurchaseInfo.asGroups"
              :key="index"
              :class="{'vc-node-selected': centralizedPurchaseInfo.conditions.asGroupId === item.avgId}"
              @click="swatch(item)"
            >
              {{item.avgName}}
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="20">
        <el-row v-if="centralizedPurchaseInfo.component === 'centralizedPurchase'">
          <el-col :span="24">
            <el-card class="box-card">
              <div slot="header" class="clearfix flex justify-between">
                <span>{{ $t('centralizedPurchase.queryCondition') }}</span>
              </div>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-select 
                    v-model="centralizedPurchaseInfo.conditions.asType" 
                    :placeholder="$t('centralizedPurchase.selectServiceType')"
                    style="width:100%"
                  >
                    <el-option 
                      v-for="item in serviceTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
                <el-col :span="6">
                  <el-input 
                    v-model="centralizedPurchaseInfo.conditions.asName" 
                    :placeholder="$t('centralizedPurchase.inputServiceName')"
                  />
                </el-col>
                <el-col :span="6">
                  <el-select 
                    v-model="centralizedPurchaseInfo.conditions.state" 
                    :placeholder="$t('centralizedPurchase.selectStatus')"
                    style="width:100%"
                  >
                    <el-option 
                      v-for="item in statusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
                <el-col :span="6">
                  <el-button 
                    type="primary" 
                    size="small" 
                    @click="_queryAppServiceMethod()"
                  >
                    <i class="el-icon-search"></i> {{ $t('centralizedPurchase.search') }}
                  </el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-card class="box-card">
              <div slot="header" class="clearfix flex justify-between">
                <span>{{ $t('centralizedPurchase.appService') }}</span>
                <div style="float: right;">
                  <el-button-group>
                    <el-button 
                      size="small" 
                      @click="_restartMoreApps()"
                    >
                      {{ $t('centralizedPurchase.restartAll') }}
                    </el-button>
                    <el-button 
                      size="small" 
                      @click="_openAddAppServiceModal()"
                    >
                      {{ $t('centralizedPurchase.addService') }}
                    </el-button>
                    <el-button 
                      size="small" 
                      @click="_openFasterDeploy()"
                    >
                      {{ $t('centralizedPurchase.quickDeploy') }}
                    </el-button>
                    <el-button 
                      size="small" 
                      @click="_importYaml()"
                    >
                      {{ $t('centralizedPurchase.import') }}
                    </el-button>
                    <el-button 
                      size="small" 
                      @click="_exportYaml()"
                    >
                      {{ $t('centralizedPurchase.export') }}
                    </el-button>
                  </el-button-group>
                </div>
              </div>
              
              <centralized-purchase-table 
                :data="centralizedPurchaseInfo.goods"
                @control="_openControl"
                @copy="_copyAppService"
                @upgrade="_upgradeAppService"
                @start="_startAppService"
                @stop="_stopAppService"
                @delete="_openDeleteAppServiceModel"
                @log="_openDockerLog"
              />

              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="centralizedPurchaseInfo.conditions.page"
                :page-size="centralizedPurchaseInfo.conditions.row"
                layout="total, prev, pager, next"
                :total="centralizedPurchaseInfo.total"
                style="margin-top: 20px; text-align: right;"
              />
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getAppService, getAppVarGroup } from '@/api/goods/centralizedPurchaseApi'
import CentralizedPurchaseTable from '@/components/goods/centralizedPurchase/centralizedPurchaseTable'

export default {
  name: 'CentralizedPurchase',
  components: {
    CentralizedPurchaseTable
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      centralizedPurchaseInfo: {
        goods: [],
        total: 0,
        records: 1,
        moreCondition: false,
        component: 'centralizedPurchase',
        asId: '',
        asGroups: [],
        conditions: {
          asName: '',
          asType: '',
          asCount: '',
          asGroupId: '',
          state: '',
          page: 1,
          row: 10
        }
      },
      serviceTypes: [],
      statusOptions: []
    }
  },
  created() {
    this._initMethod()
    this._initEvent()
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const {data} = await getDict('app_service', 'as_type')
        const {data: statusOptions} = await getDict('app_service', 'state')
        this.serviceTypes = data
        this.statusOptions = statusOptions
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    _initMethod() {
      this._listListAppVarGroups()
    },
    _initEvent() {
      this.$on('centralizedPurchase', 'listAppService', (param) => {
        console.log(param)
        this.centralizedPurchaseInfo.component = 'centralizedPurchase'
        this._listAppServices(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      })
    },
    async _listAppServices(page, rows) {
      this.centralizedPurchaseInfo.conditions.page = page
      this.centralizedPurchaseInfo.conditions.row = rows
      
      try {
        const res = await getAppService(this.centralizedPurchaseInfo.conditions)
        this.centralizedPurchaseInfo.total = res.total
        this.centralizedPurchaseInfo.records = res.records
        this.centralizedPurchaseInfo.goods = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _listListAppVarGroups() {
      try {
        const res = await getAppVarGroup({ page: 1, row: 50 })
        this.centralizedPurchaseInfo.asGroups = res.data
        if (res.data.length > 0) {
          this.centralizedPurchaseInfo.conditions.asGroupId = res.data[0].avgId
          this._listAppServices(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
        }
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    handleCurrentChange(val) {
      this.DEFAULT_PAGE = val
      this._listAppServices(val, this.DEFAULT_ROWS)
    },
    _openAddAppServiceModal() {
      this.centralizedPurchaseInfo.component = 'addAppService'
      this.$emit('addAppService', 'openAddAppServiceModal', {})
    },
    _openControl(appService) {
      this.$router.push(`/pages/admin/appServiceControl?asId=${appService.asId}`)
    },
    _copyAppService(appService) {
      this.$emit('copyAppService', 'openCopyAppServiceModal', appService)
    },
    _upgradeAppService(appService) {
      this.$emit('upgradeAppService', 'openUpgradeAppServiceModal', appService)
    },
    _openDeleteAppServiceModel(appService) {
      this.$emit('deleteAppService', 'openDeleteAppServiceModal', appService)
    },
    _queryAppServiceMethod() {
      this._listAppServices(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _moreCondition() {
      console.log(this.centralizedPurchaseInfo.moreCondition)
      this.centralizedPurchaseInfo.moreCondition = !this.centralizedPurchaseInfo.moreCondition
    },
    async _startAppService(appService) {
      try {
        await this.$http.post('/appService/startAppService', appService)
        this.$message.success(this.$t('centralizedPurchase.startSuccess'))
        this.$emit('centralizedPurchase', 'listAppService', {})
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async _stopAppService(appService) {
      try {
        await this.$http.post('/appService/stopAppService', appService)
        this.$message.success(this.$t('centralizedPurchase.stopSuccess'))
        this.$emit('centralizedPurchase', 'listAppService', {})
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    _openFasterDeploy() {
      this.$router.push('/pages/admin/fasterDeploy')
    },
    _exportYaml() {
      this.$emit('selectAppService', 'openSelectAppService', {
        asGroupId: this.centralizedPurchaseInfo.conditions.asGroupId,
        callBack: this._doExportYaml
      })
    },
    _doExportYaml(asIds) {
      window.location.href = `/app/appService/exportAppService?asIds=${asIds}`
    },
    _importYaml() {
      this.$emit('importAppService', 'openImportAppServiceModal', {})
    },
    _restartMoreApps() {
      this.$emit('selectAppService', 'openSelectAppService', {
        asGroupId: this.centralizedPurchaseInfo.conditions.asGroupId,
        callBack: this._doRestartMoreApps
      })
    },
    async _doRestartMoreApps(asIds) {
      try {
        await this.$http.post('/appService/restartAppServices', { asIds })
        this.$message.success(this.$t('centralizedPurchase.restartRequestSent'))
        this.$emit('centralizedPurchase', 'listAppService', {})
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    _openDockerLog(appService) {
      this.$emit('chooseHostContainer', 'openChooseHostContainerModel', appService)
    },
    swatch(item) {
      this.centralizedPurchaseInfo.conditions.asGroupId = item.avgId
      this._listAppServices(1, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.padding-right-0 {
  padding-right: 0;
}
.bg-white {
  background-color: #fff;
}
.treeview {
  height: 100%;
  overflow-y: auto;
}
.list-group {
  padding-left: 0;
  margin-bottom: 0;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
  cursor: pointer;
}
.list-group-item:hover {
  background-color: #f5f5f5;
}
.vc-node-selected {
  background-color: #409EFF;
  color: #fff;
}
.text-center {
  text-align: center;
}
</style>